import { TooltipCell } from '@/components/Table/components/Cell/ToolTipCell'

import { PriceCell, RawTextCell } from '@/components/Table/components/Cell'
import DateCell from '@/components/Table/components/Cell/DateCell'
import { createColumnHelper } from '@tanstack/react-table'
import { FilterType } from '@/components/Table/components/Filter/TableFilter'

export const getOfferListCommonColumns = ({
  salesUserOptions = [],
  creatorOptions = [],
  teamOptions = [],
  businessUnitOptions = [],
  PMOptions = [],
  costCenterOptions = [],
  GCKOptions = [],
}) => {
  const columnHelper = createColumnHelper()

  return [
    columnHelper.accessor('salesResponsible', {
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: salesUserOptions,
      },
    }),
    columnHelper.accessor('creator', {
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: creatorOptions,
      },
    }),
    columnHelper.accessor('projectName', {
      size: 200,
      cell: RawTextCell,
    }),
    columnHelper.accessor('customer', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('quotationNumber', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('revision', {
      header: () => <span>Version</span>,
    }),
    columnHelper.accessor('team', {
      cell: RawTextCell,
      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: teamOptions,
      },
    }),
    columnHelper.accessor('businessUnit', {
      cell: RawTextCell,
      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: businessUnitOptions,
      },
    }),
    columnHelper.accessor('totalContractPrice', {
      cell: ({ getValue, row: { original } }) => <PriceCell currency={original.currency} getValue={getValue} />,

      meta: {
        filterVariant: FilterType.RANGE,
      },
    }),

    columnHelper.accessor('updatedAt', {
      header: () => <span>Last Update</span>,
      cell: DateCell,
      meta: {
        filterVariant: FilterType.DATE,
      },
    }),
    columnHelper.accessor('createdAt', {
      header: () => <span>Create Date</span>,
      cell: DateCell,
      meta: {
        filterVariant: FilterType.DATE,
      },
    }),
    columnHelper.accessor('countryOfInstallation', {
      cell: ({ getValue }) => {
        let textValue = getValue()
        if (getValue() === 'hk') {
          textValue = 'Hong Kong'
        } else if (getValue() === 'mo') {
          textValue = 'Macau'
        } else if (getValue() === 'others') {
          textValue = 'CN / Overseas'
        }
        return <TooltipCell text={textValue} />
      },
      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: [
          { label: 'Hong Kong', value: 'hk' },
          { label: 'Macau', value: 'mo' },
          { label: 'CN/Overseas', value: 'others' },
        ],
      },
    }),
    columnHelper.accessor('engineers'),
    columnHelper.accessor('manager', {
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: PMOptions,
      },
    }),
    columnHelper.accessor('projectStartDate', {
      cell: DateCell,
      meta: {
        filterVariant: FilterType.DATE,
      },
    }),
    columnHelper.accessor('projectEndDate', {
      cell: DateCell,
      meta: {
        filterVariant: FilterType.DATE,
      },
    }),
    columnHelper.accessor('endCustomer', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('profitCenter', {
      cell: RawTextCell,
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: costCenterOptions,
      },
    }),
    columnHelper.accessor('grossMargin', {
      cell: ({ getValue }) => {
        return <TooltipCell text={`${getValue() || 0}%`} />
      },
      meta: {
        filterVariant: FilterType.RANGE,
      },
    }),
    columnHelper.accessor('offerSubmissionDate', {
      cell: DateCell,
      meta: {
        filterVariant: FilterType.DATE,
      },
    }),
    columnHelper.accessor('SISIC', {
      header: () => <span>SISIC</span>,
      cell: RawTextCell,
    }),
    columnHelper.accessor('isSiemensStandardTerms', {
      header: () => <span>Siemens Standard Terms</span>,

      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: [
          { label: 'Yes', value: 'yes' },
          { label: 'No', value: 'no' },
          { label: 'No (With Legal Waiver)', value: 'noWithLegalWaiver' },
        ],
      },
    }),
    columnHelper.accessor('GCKCode', {
      header: () => <span>GCK</span>,
      cell: RawTextCell,
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: GCKOptions,
      },
    }),
    columnHelper.accessor('requirePhysicalSignature', {
      header: () => <span>Physical Signature</span>,

      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: [
          { label: 'Required', value: 'required' },
          { label: 'Not Required', value: 'notRequired' },
        ],
      },
    }),
    columnHelper.accessor('wbsNumber', {
      header: () => <span>Booking WBS #</span>,
      cell: RawTextCell,
    }),
    columnHelper.accessor('customerPONumber', {
      header: () => <span>Customer PO #</span>,
      cell: RawTextCell,
    }),
    columnHelper.accessor('site', {
      header: () => <span>Site</span>,
    }),
    columnHelper.accessor('customerReference', {
      header: () => <span>Customer Ref.</span>,
    }),

    columnHelper.accessor('isClosed', {
      header: () => <span>Closed</span>,
      meta: {
        filterVariant: FilterType.SELECT_YES_NO,
      },
    }),
  ]
}
